<template>
  <header class="header menu_fixed bg-white px-5  navbar-expand-lg">
    <button class="navbar-toggler float-right" type="button" data-toggle="collapse" data-target="#navbarsExampleDefault"
      aria-controls="navbarsExampleDefault" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon fa fa-bars text-purple"></span> </button>

    <div id="logo" class="tex-center col-9  col-sm-10 col-md-11 col-lg-3 col-xl-3 d-flex  justify-content-between">
      <!-- <a :href="`${momsiteURL}`">
        <img :src="`${publicPath}assets/img/logo-sm.png`" height="45" data-retina="true" alt="" class="logo_normal" />
      </a> -->
      <router-link to="/home"><img :src="`${publicPath}assets/img/logo-sm.png`" height="45" data-retina="true" alt="" class="logo_normal" /></router-link>
      <div class="searcbox float-end ">
        <global-search v-if="showHeaderSearch" key="header"></global-search>
      </div>
    </div>

    <div class="collapse navbar-collapse col-md-9 col-lg-9 col-xl-9 " id="navbarsExampleDefault">
      <!-- <div class="col-md-6  col-12 d-sm-none">
        <div id="logo">
          <a :href="`${momsiteURL}`">
            <img :src="`${publicPath}assets/img/logo-sm.png`" width="150" height="36" data-retina="true" alt=""
              class="logo_normal" />
            <img :src="`${publicPath}assets/img/logo-sm.png`" width="150" height="36" data-retina="true" alt=""
              class="logo_sticky" />
          </a>
        </div>
      </div> -->
      <div class="col-md-12 col-lg-7 col-xl-7 p-0  d-flex justify-content-xl-center justify-content-lg-center ">
        <nav class="main-menu">
          <ul>
            <li>
              <!-- name: "Home" -->
              <span>

                <a :class="{ active: currentTab.includes('/home') }" :href="eznatalBusinessURL">Business</a>
              </span>
            </li>

            <li>
              <span><router-link :class="{ active: currentTab.includes('/faq') }" to="/faq">FAQ</router-link></span>
            </li>
            <li>
              <span><router-link :class="{ active: currentTab.includes('/blog') }" to="/blog">Blog</router-link></span>
            </li>
            <li>
              <span><router-link to="/support-request"
                  :class="{ active: currentTab.includes('/support-request') }">Support Request</router-link></span>
            </li>
          </ul>
        </nav>

      </div>

      <div class="d-block d-sm-none d-md-none d-lg-block position-relative col-md-10 col-lg-3 col-xl-4 searchBar-top p-md-0 p-lg-0 " style="">
        <global-search v-if="showHeaderSearch" key="header"></global-search>
      </div>
      <div class=" login col-md-3 col-lg-2 col-xl-1 d-flex ">
        <nav class="main-menu">
          <ul>
            <li v-if="isLoggedIn">
              <span><a href="javascript:void(0);" @click="logOut">Logout <i class="bi bi-box-arrow-right"></i></a></span> 
            </li>
            <li v-else>
              <span>
                <router-link :class="{ 'btn': true, 'btn-custom': true }" to="/login">Login</router-link>
              </span>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </header>
  <!-- /header -->
</template>

<script>
import GlobalSearch from '../Common/globalSearch.vue'
export default {
  name: 'HeaderNavigation',
  data() {
    return {
      publicPath: process.env.BASE_URL,
      momsiteURL: process.env.VUE_APP_MOMSITE_BASE_URL,
      eznatalBusinessURL: process.env.VUE_APP_BUSINESS_URL,
      mobileMenu: false
    }
  },
  components: {
    GlobalSearch
  },
  watch: {

  },
  computed: {
    currentTab() {
      return this.$route.path.toLowerCase()
    },
    isLoggedIn() {
      return this.$store.state.auth.loggedInState
    },
    showHeaderSearch() {
      return !this.$route.path.includes('home')
    }
  },
  methods: {
    logOut() {
      this.$store.dispatch('logout')
      this.$router.push('/home')
    },
    showMobileMenu() {
      this.mobileMenu = true
    }
  }
}
</script>
